import request from '@/router/axios'
import env from '@/config/env'

// 获取分页
export const driverDataPage = (params) => {
  return request({
    url: env.ferryUrl + '/driver-data/page',
    method: 'POST',
    data: params
  })
}
// 获取详情
export const detail = (params) => {
  return request({
    url: env.ferryUrl + '/driver-data/detail',
    method: 'GET',
    params
  })
}
// 获取订单分页
export const orderPage = (params) => {
  return request({
    url: env.ferryUrl + '/driver-data/order/page',
    method: 'POST',
    data: params
  })
}
// 获取订单分页
export const driverDataJob = (params) => {
  return request({
    url: env.ferryUrl + '/driver-data/job',
    method: 'GET',
    params
  })
}
// 获取投诉
export const complaint = (params) => {
  return request({
    url: env.ferryUrl + '/driver-data/complaint',
    method: 'POST',
    params
  })
}
